if (!customElements.get('native-delivery-estimate')) {
  customElements.define(
    'native-delivery-estimate',
    class NativeDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.renderDates();
      }

      renderDates() {
        const orderedDate = this.normalizedDate(new Date());
        const readyMinDays = this.numberFromDataset('readyMin');
        const readyMaxDays = Math.max(readyMinDays, this.numberFromDataset('readyMax'));
        const deliveryMinDays = this.numberFromDataset('deliveryMin');
        const deliveryMaxDays = Math.max(deliveryMinDays, this.numberFromDataset('deliveryMax'));
        const businessDaysOnly = this.dataset.businessDaysOnly === 'true';

        const dates = {
          ordered: [orderedDate, orderedDate],
          ready: [
            this.addDays(orderedDate, readyMinDays, businessDaysOnly),
            this.addDays(orderedDate, readyMaxDays, businessDaysOnly),
          ],
          delivered: [
            this.addDays(orderedDate, deliveryMinDays, businessDaysOnly),
            this.addDays(orderedDate, deliveryMaxDays, businessDaysOnly),
          ],
        };

        Object.entries(dates).forEach(([name, range]) => {
          const output = this.querySelector(`[data-delivery-date="${name}"]`);
          if (!output) return;

          output.textContent = this.formatRange(range[0], range[1]);
          output.dateTime = range[0].toISOString().slice(0, 10);
        });
      }

      numberFromDataset(key) {
        const value = Number.parseInt(this.dataset[key], 10);
        return Number.isFinite(value) ? Math.max(0, value) : 0;
      }

      normalizedDate(date) {
        const result = new Date(date);
        result.setHours(12, 0, 0, 0);
        return result;
      }

      addDays(date, days, businessDaysOnly) {
        const result = this.normalizedDate(date);
        let remaining = days;

        while (remaining > 0) {
          result.setDate(result.getDate() + 1);
          const day = result.getDay();
          if (!businessDaysOnly || (day !== 0 && day !== 6)) remaining -= 1;
        }

        return result;
      }

      formatRange(start, end) {
        const locale = this.dataset.locale || document.documentElement.lang || 'en';
        let formatter;

        try {
          formatter = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
        } catch (error) {
          formatter = new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' });
        }

        const startLabel = formatter.format(start);
        const endLabel = formatter.format(end);
        if (startLabel === endLabel) return startLabel;

        if (typeof formatter.formatRange === 'function') {
          return formatter.formatRange(start, end);
        }

        return `${startLabel}–${endLabel}`;
      }
    }
  );
}
